import React, { useEffect, useState } from 'react';

// We initially used styled-components for styling, but encountered issues with the CSS not being applied correctly
// hence leading to the decision to switch to a CSS file for styling.
// We will revert to styled once we figure out the issue with styled-components.

import "./SkipToQcp.css"; // Ensure the CSS file is imported

const SkipToQcp = () => {
    const [showSkipToQcp, setShowSkipToQcp] = useState("off");
    useEffect (() => {
      setShowSkipToQcp("on");
    }, []);

    const handleClick = (event) => {
      event.preventDefault();
      const form = document.querySelector("form.mobius-submission__questionnaire-form")
        || document.querySelector(".btn-primary.arrow.qa-next-button.js-next-button")?.closest("form");

      if (form) {
        let hiddenField = form.querySelector('input[name="skip_to_qcp"]');
        if (!hiddenField) {
          hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = "skip_to_qcp";
          form.appendChild(hiddenField);
        }
        hiddenField.value = "true";
        form.requestSubmit();
      }
    };

  return <>
    <div id="skip-to-qcp-container" className={showSkipToQcp}>
      <button id="skip-to-qcp-button" onClick={handleClick}>
        Skip to QCP
      </button>
    </div>
  </>; 
};

export default SkipToQcp;
